// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".visualization-options-container .txt{font-size:14px;margin-bottom:10px;margin-top:20px;color:#51606d}.visualization-options-container .txt.title{font-size:16px}.visualization-options-container .buttons{display:flex;flex-direction:row-reverse;margin-top:60px;margin-bottom:50px;width:50%}.visualization-options-container .buttons #btn-select-options{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
